export default["__VITE_ASSET__2O6pxeE___","__VITE_ASSET__2mMRRRU$__"];